export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  datePublished: string;
  dateModified: string;
  category: string;
  author: {
    id: string;
    name: string;
    jobTitle: string;
    image: string;
  };
  readTime: string;
  customPath: string;
  isFeatured: boolean;
  image: string;
}

// Define sitemap entry type
interface SitemapEntry {
  url: string;
  lastModified: string;
  changeFrequency: "yearly" | "weekly" | "always" | "hourly" | "daily" | "monthly" | "never";
  priority: number;
}

export const blogPostsData: BlogPost[] = [
  
  /*{
    id: 'bridge-between-tech-emotion',
    title: 'The Bridge Between Tech and Emotion',
    excerpt: 'Drawing on over two decades of experience in film, television, and live events, our CBDO explores how the principles of creative storytelling translate to building human-centered commerce technology that fosters genuine connections.',
    date: '2025-11-08',
    datePublished: '2025-11-07T10:00:00Z',
    dateModified: '2025-11-07T11:00:00Z',
    category: 'customer-experience',
    author: {
      id: 'anti-reinthal',
      name: 'Anti Reinthal',
      jobTitle: 'Chief Business Development Officer',
      image: '/images/team/anti-reinthal.jpg'
    },
    readTime: '8 min read',
    customPath: '/blog/bridge-between-tech-emotion',
    isFeatured: false,
    image: '/images/blog/bridge-between-tech-emotion.jpg'
  },*/
  {
    id: 'engineering-future-agentic-commerce',
    title: 'Engineering the Future of Agentic Commerce: An API-First Approach to the AI-Native Web',
    excerpt: 'The internet is transforming from a web of pages to a web of agents. At Perxify, we\'re engineering the API-first, AI-native infrastructure that will power autonomous commerce.',
    date: '2025-11-05',
    datePublished: '2025-11-05T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'ai',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '12 min read',
    customPath: '/blog/engineering-future-agentic-commerce',
    isFeatured: false,
    image: '/images/blog/engineering-future-agentic-commerce.png'
  },
  {
    id: 'crypto-ai-convergence',
    title: 'AI-Powered Commerce Cloud: The Convergence of Crypto and AI',
    excerpt: 'The A16Z State of Crypto report validates Perxify\'s strategy: integrating wallets for programmable identity, NFTs for perpetual ownership, and AI for intelligence, with BooksShark as the first use case.',
    date: '2025-10-27',
    datePublished: '2025-10-27T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'ai',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '15 min read',
    customPath: '/blog/crypto-ai-convergence',
    isFeatured: false,
    image: '/images/blog/crypto-ai-convergence-featured.png'
  },
  {
    id: 'estonia-retail-innovation-economic-pressure',
    title: 'When Economic Pressure Sparks Innovation: Lessons from Estonia\'s Retail Evolution',
    excerpt: 'Estonia\'s VAT increase is creating challenges for retailers but also opening doors for AI-driven solutions and direct-to-consumer strategies across Europe.',
    date: '2025-06-28',
    datePublished: '2025-06-28T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'policy',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '8 min read',
    customPath: '/blog/estonia-retail-innovation-economic-pressure',
    isFeatured: false,
    image: '/images/blog/estonia-retail-innovation-opportunity.jpg'
  },
  {
    id: 'estonia-digital-leadership-pioneering-future-digital-identity',
    title: 'Estonia\'s Digital Leadership: Pioneering the Future of Digital Identity in Europe',
    excerpt: "Estonia is setting the standard for Europe's digital future through the EUDI Wallet project, which combines cutting-edge technology with user-centric design and open-source collaboration.",
    date: '2025-06-20',
    datePublished: '2025-06-20T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'policy',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '18 min read',
    customPath: '/blog/estonia-digital-leadership-pioneering-future-digital-identity',
    isFeatured: false,
    image: '/images/blog/estonia-digital-leadership-pioneering-future-digital-identity.webp'
  },
  {
    id: 'commerce-in-the-agentic-web',
    title: 'Commerce in the Agentic Web: The New Rules for AI-Mediated Value Exchange',
    excerpt: 'As AI agents become our primary interface with the web, businesses must balance optimizing for both human attention and AI comprehension, creating a new economic model based on direct value exchange.',
    date: '2025-05-26',
    datePublished: '2025-05-26T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'commerce',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '12 min read',
    customPath: '/blog/commerce-in-the-agentic-web',
    isFeatured: false,
    image: '/images/blog/commerce-in-the-agentic-web.jpg'
  },
  {
    id: 'ai-powered-development-one-hour-website',
    title: 'AI-Powered Development: Building a Headless Commerce Frontend in One Hour',
    excerpt: 'The story of how we went from needing a website to having a live, professional headless commerce frontend in just one hour using AI assistance - and what this means for the future of startup development.',
    date: '2025-04-25',
    datePublished: '2025-04-25T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'ai',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '10 min read',
    customPath: '/blog/ai-powered-development-one-hour-website',
    isFeatured: false,
    image: '/images/blog/ai-powered-development-one-hour-website.jpg'
  },
  {
    id: 'business-model-evolution-risk-sharing',
    title: 'Business Model Evolution: From Upfront Fees to Risk-Sharing Success',
    excerpt: "How discovering that brands need modern commerce infrastructure but can't afford upfront investments led us to develop a revolutionary risk-sharing business model based on transaction fees.",
    date: '2025-04-17',
    datePublished: '2025-04-17T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'entrepreneurship',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '11 min read',
    customPath: '/blog/business-model-evolution-risk-sharing',
    isFeatured: false,
    image: '/images/blog/business-model-evolution-risk-sharing.jpg'
  },
  {
    id: 'perxify-personal-shopping-experience',
    title: 'AI Product Recommendation Engine: How Perxify Makes Online Shopping Personal Again',
    excerpt: 'Discover how Perxify is reimagining e-commerce by creating a commerce cloud that connects brands and shoppers on a shared infrastructure that learns and adapts, powered by our AI product recommendation engine.',
    date: '2025-04-03',
    datePublished: '2025-04-03T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'customer-experience',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '12 min read',
    customPath: '/blog/perxify-personal-shopping-experience',
    isFeatured: true,
    image: '/images/blog/perxify-personal-shopping-experience.png'
  },
  {
    id: 'future-web-html6-web4-next-generation-internet',
    title: 'The Future Web: Headless Commerce, Web4, and the Next Generation of Internet Technology',
    excerpt: 'Exploring the vision for HTML6 as the foundation of Web4 - a symbiotic web that integrates XR, IoT, AI, and blockchain technologies to create seamless digital-physical experiences, built on a headless commerce foundation.',
    date: '2025-03-20',
    datePublished: '2025-03-20T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'ai',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '22 min read',
    customPath: '/blog/future-web-html6-web4-next-generation-internet',
    isFeatured: false,
    image: '/images/blog/future-web-html6-web4-next-generation-internet.webp'
  },
  {
    id: 'enterprise-interest-and-commerce-infrastructure',
    title: 'API-First Commerce: Building Enterprise Infrastructure from the Ground Up',
    excerpt: 'How enterprise interest and client validation transformed our understanding of the market opportunity, leading us to rebuild commerce infrastructure from the ground up with an API-first approach.',
    date: '2025-03-18',
    datePublished: '2025-03-18T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'growth',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '14 min read',
    customPath: '/blog/enterprise-interest-and-commerce-infrastructure',
    isFeatured: false,
    image: '/images/blog/enterprise-interest-and-commerce-infrastructure.jpg'
  },
  {
    id: 'big-pivot-loyalty-to-commerce-cloud',
    title: 'The Big Pivot: From Loyalty Platform to Headless Commerce Cloud',
    excerpt: 'The strategic decision that changed everything - how we realized we had built a headless commerce cloud, not just a loyalty platform, and the benefits of this API-first architecture.',
    date: '2025-01-29',
    datePublished: '2025-01-29T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'commerce',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '13 min read',
    customPath: '/blog/big-pivot-loyalty-to-commerce-cloud',
    isFeatured: false,
    image: '/images/blog/loyalty-to-commerce-pivot.jpg'
  },
  {
    id: 'marketing-age-ai-strategies-2025-beyond',
    title: 'AI Marketing Strategies for 2025 and Beyond: Hyper-Personalization and Agentic Commerce',
    excerpt: 'How artificial intelligence is fundamentally transforming marketing strategies, from hyper-personalization and conversational commerce to the rise of intelligent agents and immersive experiences.',
    date: '2025-01-28',
    datePublished: '2025-01-28T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'growth',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '16 min read',
    customPath: '/blog/marketing-age-ai-strategies-2025-beyond',
    isFeatured: false,
    image: '/images/blog/marketing-age-ai-strategies-2025-beyond.webp'
  },
  {
    id: 'market-context-estonian-ecosystem-2025',
    title: 'Market Context: The Estonian Startup Ecosystem in 2025',
    excerpt: 'An analysis of the Estonian startup ecosystem in 2025 and how local market dynamics influenced our global platform strategy.',
    date: '2025-01-09',
    datePublished: '2025-01-09T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'policy',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '8 min read',
    customPath: '/blog/market-context-estonian-ecosystem-2025',
    isFeatured: false,
    image: '/images/blog/estonian-startup-ecosystem-2025.jpg'
  },
  {
    id: 'demo-to-reality-first-marketplace',
    title: 'From Demo to Reality: Building a Headless Multi-Vendor Marketplace',
    excerpt: 'The journey from proof-of-concept to first marketplace product, including the technical challenges and business insights we discovered while building a headless multi-vendor solution.',
    date: '2025-01-06',
    datePublished: '2025-01-06T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'commerce',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '12 min read',
    customPath: '/blog/demo-to-reality-first-marketplace',
    isFeatured: false,
    image: '/images/blog/demo-to-reality-first-marketplace.jpg'
  },
  {
    id: '2024-year-end-reflections',
    title: '2024 Reflections: A Year of Building Perxify',
    excerpt: 'A comprehensive look back at 2024 - the challenges overcome, lessons learned, and foundation built for the future of Perxify.',
    date: '2024-12-28',
    datePublished: '2024-12-28T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'entrepreneurship',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '15 min read',
    customPath: '/blog/2024-year-end-reflections',
    isFeatured: false,
    image: '/images/blog/2024-year-end-reflections.jpg'
  },
  {
    id: 'ai-beyond-tools-trends-transformative-applications',
    title: 'Transformative AI Applications in E-commerce: Beyond Tools and Trends',
    excerpt: 'A comprehensive analysis of AI\'s evolution through 2025, from ambitious predictions to remarkable developments, exploring the tools, frameworks, and transformative applications defining the future of e-commerce.',
    date: '2024-12-10',
    datePublished: '2024-12-10T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'ai',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '20 min read',
    customPath: '/blog/ai-beyond-tools-trends-transformative-applications',
    isFeatured: false,
    image: '/images/blog/ai-beyond-tools-trends-transformative-applications.webp'
  },
  {
    id: 'momentum-growth-enterprise-interest',
    title: 'Momentum and Growth: Enterprise Interest in Headless Commerce Platforms',
    excerpt: 'How enterprise interest validated our platform approach and drove rapid maturation of our technology and business model, focusing on the demand for headless commerce solutions.',
    date: '2024-11-19',
    datePublished: '2024-11-19T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'growth',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '10 min read',
    customPath: '/blog/momentum-growth-enterprise-interest',
    isFeatured: false,
    image: '/images/blog/momentum-growth-enterprise-interest.jpg'
  },
  {
    id: 'web3-future-commerce-blockchain-secondary-markets',
    title: 'Web3 and the Future of Commerce: Tokenized Loyalty and Digital Ownership',
    excerpt: 'How Web3 technologies are revolutionizing customer loyalty and secondary markets through blockchain integration, digital certificates, and true ownership models.',
    date: '2024-11-16',
    datePublished: '2024-11-16T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'commerce',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '17 min read',
    customPath: '/blog/web3-future-commerce-blockchain-secondary-markets',
    isFeatured: true,
    image: '/images/blog/web3-future-commerce-blockchain-secondary-markets.webp'
  },
  {
    id: 'evolution-customer-loyalty-points-partnerships',
    title: 'The Evolution of Customer Loyalty: From Points to Tokenized Rewards',
    excerpt: 'How modern brands are reimagining customer relationships, moving beyond traditional point systems to create genuine partnerships through technology, personalization, and community building, powered by tokenized rewards.',
    date: '2024-11-11',
    datePublished: '2024-11-11T10:00:00Z',
    dateModified: '2025-11-12T13:30:00Z',
    category: 'customer-experience',
    author: {
      id: 'alvar-laigna',
      name: 'Alvar Laigna',
      jobTitle: 'Co-Founder & CTO',
      image: '/images/team/alvar-laigna.jpg'
    },
    readTime: '19 min read',
    customPath: '/blog/evolution-customer-loyalty-points-partnerships',
    isFeatured: false,
    image: '/images/blog/evolution-customer-loyalty-points-partnerships.webp'
  },
  {
    id: 'reality-of-building-startups',
    title: 'The Reality of Building: Scope Creep and Strategic Pivots',
    excerpt: 'The honest story of how scope creep nearly derailed our development and how we learned to embrace it as market validation rather than fight it.',
    date: '2024-10-30',
    datePublished: '2024-10-30T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'ai',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '11 min read',
    customPath: '/blog/reality-of-building-startups',
    isFeatured: false,
    image: '/images/blog/reality-of-building-startups.jpg'
  },
  {
    id: 'philosophy-behind-perxify',
    title: 'The Philosophy Behind Perxify: Rethinking Brand-Consumer Relationships',
    excerpt: 'The core philosophy that drives Perxify - moving beyond transactional relationships to create genuine partnerships between brands and customers.',
    date: '2024-10-10',
    datePublished: '2024-10-10T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'customer-experience',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '9 min read',
    customPath: '/blog/philosophy-behind-perxify',
    isFeatured: false,
    image: '/images/blog/philosophy-behind-perxify.jpg'
  },
  {
    id: 'concept-to-platform-evolution-2024',
    title: 'From Concept to Platform: Perxify\'s Evolution Through 2024',
    excerpt: 'How Perxify evolved from a simple loyalty program idea into a comprehensive commerce platform throughout 2024.',
    date: '2024-09-16',
    datePublished: '2024-09-16T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'entrepreneurship',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '12 min read',
    customPath: '/blog/concept-to-platform-evolution-2024',
    isFeatured: false,
    image: '/images/blog/concept-to-platform-evolution-2024.jpg'
  },
  {
    id: 'technical-reality-web3-challenges',
    title: 'The Technical Reality: Web3 Building Challenges',
    excerpt: 'The honest truth about building on blockchain technology - from integration complexities to user experience challenges and everything in between.',
    date: '2024-07-07',
    datePublished: '2024-07-09T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'ai',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '10 min read',
    customPath: '/blog/technical-reality-web3-challenges',
    isFeatured: false,
    image: '/images/blog/technical-reality-web3-challenges.jpg'
  },
  {
    id: 'building-in-public-early-days',
    title: 'Building in Public: The Early Days of Perxify',
    excerpt: 'A look back at the initial decision to build Perxify in the open, sharing our progress, challenges, and lessons learned with the community.',
    date: '2024-06-08',
    datePublished: '2024-06-08T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'entrepreneurship',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '8 min read',
    customPath: '/blog/building-in-public-early-days',
    isFeatured: false,
    image: '/images/blog/building-in-public-early-days.jpg'
  },
  {
    id: 'fifteen-years-journey-perxify',
    title: 'Fifteen Years in the Making: The Journey to Building Perxify',
    excerpt: 'A personal reflection on the entrepreneurial journey that led to Perxify - from early ecommerce ventures to finding the right problem to solve.',
    date: '2024-05-29',
    datePublished: '2024-05-29T10:00:00Z',
    dateModified: '2025-07-30T16:45:00Z',
    category: 'entrepreneurship',
    author: {
      id: 'sander-gansen',
      name: 'Sander Gansen',
      jobTitle: 'Co-Founder & CEO',
      image: '/images/team/sander-gansen.jpg'
    },
    readTime: '6 min read',
    customPath: '/blog/fifteen-years-journey-perxify',
    isFeatured: false,
    image: '/images/blog/entrepreneurial-journey-reflection.jpg'
  },
];

export const getBlogPosts = async (): Promise<BlogPost[]> => {
  try {
    // Simulate API fetch with delay
    await new Promise(resolve => setTimeout(resolve, 500));
    return blogPostsData;
  } catch (error) {
    console.error('Failed to fetch blog posts:', error);
    throw new Error('Unable to load blog posts');
  }
};

export const getSitemapData = (): SitemapEntry[] => {
  return blogPostsData.map(post => ({
    url: post.customPath,
    lastModified: new Date(post.dateModified).toISOString(),
    changeFrequency: 'yearly' as const,
    priority: 0.5
  }));
};
